import { render, staticRenderFns } from "./DashCalidad.vue?vue&type=template&id=5a5a8f13"
import script from "./DashCalidad.vue?vue&type=script&lang=js"
export * from "./DashCalidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports